import { useLocation } from "react-router-dom";
import { SportTooltip } from "../../controls";
import { RightOutlined } from "@ant-design/icons";
import { Space } from "antd";

const NavMenuItem = ({label, url, img, onClick, disabled, tooltip, itemId, external, badgeCount = 0, children}) => {
  const location = useLocation();
  const childItems = (children ?? []).filter(Boolean);
  const hasChildren = childItems.length > 0;
  const class2 = !external && (location.pathname === url || childItems.some((item) => location.pathname === item.url)) ? ' nav-menu-item-selected' : ''
  const badge = badgeCount > 0 ? <span className="nav-menu-badge">{badgeCount}</span> : null;

  if (hasChildren) {

    return <div id={itemId} className={"nav-menu-item nav-menu-item-parent" + class2}>
      <div className="nav-menu-indicator"/>
      <div className="nav-menu-icon-row">
        <img src={`/images/${img}`} alt="logo-img" style={{width: "18px"}}/>
      </div>
      <span className="nav-menu-arrow"><RightOutlined /></span>

      {badge}
      <div>{label}</div>

      <div className="nav-menu-submenu">
        {childItems.map((item) => {
          const itemClassName = "nav-menu-submenu-item" + (location.pathname === item.url ? " nav-menu-submenu-item-selected" : "");
          const subItemId = item.id ? `tour-item-nav-menu-${item.id}` : null;
          if (item.onClick) {
            return <button key={item.key} id={subItemId} type="button" className={itemClassName} onClick={item.onClick}>
              {item.label}
            </button>
          }
          return <a key={item.key} id={subItemId} href={item.url} target={item.external ? '_blank' : undefined} rel={item.external ? 'noopener noreferrer' : undefined} className={itemClassName}>
            {item.label}
          </a>
        })}
      </div>
    </div>
  }

  if (disabled)
    return <SportTooltip  title={tooltip}><div id={itemId} className={"nav-menu-item" + class2} >
      <div className="nav-menu-indicator"/>
      <div className="nav-menu-icon-row"><img src={`/images/${img}`} alt="logo-img"/></div>
      {badge}
      <div>{label}</div>
    </div></SportTooltip>

  if (onClick)
      return <SportTooltip title={tooltip}><div id={itemId} className="nav-menu-item" onClick={onClick} style={{cursor: "pointer"}}>
        <div className="nav-menu-icon-row"><img src={`/images/${img}`} alt="logo-img"/></div>
        {badge}
        <div>{label}</div>
      </div></SportTooltip>

  return <SportTooltip title={tooltip}><a id={itemId} href={url} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className={"nav-menu-item" + class2} >
    <div className="nav-menu-indicator"/>
    <div className="nav-menu-icon-row"><img src={`/images/${img}`} alt="logo-img"/></div>
    {badge}
    <div>{label}</div>
  </a></SportTooltip>
}

export default NavMenuItem;